// extracted by mini-css-extract-plugin
module.exports = {"Card":"E_Card__ro48S"};